import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=7f52196a&lang=true"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports